import {
  getCurrentSelectedTimesheetDateString, getCurrentSelectedUserId, getSelectTimeEntryDateString,
  getShowTerminatedUsers,
} from './selectors';
import { getTimesheetUrlParamLink } from './links';

export const types = {
  SELECT_USER_ID: 'timesheetNavigator/SELECT_USER_ID',
  SELECT_TIMESHEET_DATE: 'timesheetNavigator/SELECT_TIMESHEET_DATE',
  SELECT_TIME_ENTRY_DATE: 'timesheetNavigator/SELECT_TIME_ENTRY_DATE',
  SET_SHOW_TERMINATED_USERS: 'timesheetNavigator/SET_SHOW_TERMINATED_USERS',
  SET_CALENDAR_DATE: 'timesheetNavigator/SET_CALENDAR_DATE',
  SET_DISTRICT: 'timesheetNavigator/SET_DISTRICT',
  SET_DEPARTMENT: 'timesheetNavigator/SET_DEPARTMENT',
};

const updateTimesheetUrl = (state) => {
  const userId = getCurrentSelectedUserId(state);
  const selectedTimesheetDate = getCurrentSelectedTimesheetDateString(state);
  const isTerminated = getShowTerminatedUsers(state);
  const timeEntryDate = getSelectTimeEntryDateString(state);

  return getTimesheetUrlParamLink(
    userId,
    selectedTimesheetDate,
    timeEntryDate,
    isTerminated,
  );
};

export const dispatchSelectUserId = (selectedUserId) => {
  return {
    type: types.SELECT_USER_ID,
    currentSelectedUserId: selectedUserId,
  };
};

export const dispatchSelectTimesheetDate = (timesheetDate) => {
  return {
    type: types.SELECT_TIMESHEET_DATE,
    currentSelectedTimesheetDate: timesheetDate,
  };
};

export const dispatchSelectTimeEntryDate = (timeEntryDate) => {
  return {
    type: types.SELECT_TIME_ENTRY_DATE,
    selectedTimeEntryDate: timeEntryDate,
  };
};

export const setShowTerminatedUsers = (showTerminatedUsers) => {
  return {
    type: types.SET_SHOW_TERMINATED_USERS,
    showTerminatedUsers,
  };
};

export const setDepartment = (department) => {
  return {
    type: types.SET_DEPARTMENT,
    department,
  };
};

export const setDistrict = (district) => {
  return {
    type: types.SET_DISTRICT,
    district,
  };
};

export const setSelectedDate = (dateObj) => {
  const stringDate = dateObj.toISOString().split('T')[0];
  return dispatchSelectTimeEntryDate(stringDate);
};

export const setUserIdThunk = (userId) => {
  return async (dispatch, getState, { client }) => {
    dispatch(dispatchSelectUserId(userId));
    const paramUrl = updateTimesheetUrl(getState());

    /* TODO: use injected history instead of global history */
    window.history.pushState('', '', `?${paramUrl}`);
  };
};

export const setSelectedTimesheetDateThunk = (timesheetDate) => {
  return async (dispatch, getState, { client }) => {
    dispatch(dispatchSelectTimesheetDate(timesheetDate));
    const paramUrl = updateTimesheetUrl(getState());
    window.history.pushState('', '', `?${paramUrl}`);
  };
};

export const setShowTerminatedUsersThunk = (showTerminatedUsers) => {
  return async (dispatch, getState, { client }) => {
    dispatch(setShowTerminatedUsers(showTerminatedUsers));
    const paramUrl = updateTimesheetUrl(getState());
    /* TODO: use injected history instead of global history */
    window.history.pushState('', '', `?${paramUrl}`);
  };
};

export const setSelectedTimeEntryDateThunk = (calendarDate) => {
  return async (dispatch, getState, { client }) => {
    dispatch(dispatchSelectTimeEntryDate(calendarDate));
    const paramUrl = updateTimesheetUrl(getState());

    /* TODO: use injected history instead of global history */
    window.history.pushState('', '', `?${paramUrl}`);
  };
};
